import HeadingView from "common/views/heading/Heading.view";
import { Fragment } from "core/components/FragmentProvider";
import MenuTreeView, { IMenuNode } from "common/views/menuTree/MenuTree.view";
import { Tag } from "../entities/Tag";
import NonIdealState from "common/fragments/NonIdealState";
import Loading from "common/fragments/Loading";
import TagSet from "../entities/TagSet";
import { BlockView } from "common/views/block/BlockView.view";
import labelProvider from "../UserTags.labels";
import UserTagsPanelConfig from "../config/UserTagsPanelConfig";
import Query from "core/api/QueryComponent";
import { ButtonView } from "common/views/button/Button.view";
import Label from "core/components/label/Label";
import {IUserTagsPanelState} from "../UserTags.panel";
import StringUtil from "core/util/StringUtil";
import TokenSession from "core/util/session/TokenSession";
import { SeparatorView } from "common/views/separator/Separator.view";
import { RowsView } from "common/views/rows/Rows.view";

const { Labels } = labelProvider;

export interface ITagFragmentProps {
    config: UserTagsPanelConfig;
    id: string;
	instance: string;
    onSelectTag: (node: IMenuNode<Tag>) => void;
	onSubmit: () => void;
	state: IUserTagsPanelState;
}

export const Title: Fragment<ITagFragmentProps> = {
    name: "Title",
    component: () => (
        <HeadingView viewKey="dialog.title">
            <Labels.DialogTitle />
        </HeadingView>
    )
};

export const TagList: Fragment<ITagFragmentProps> = {
    name: "Results",
    component: ({config, id, instance, state, onSelectTag}) => (
        <Query.Many entity={TagSet} args={{ids: config.tagSets || null}}>
            {
                ({data, loading}) => {

                    // TODO have this be bundle tags

                    if (loading) {
                        return <Loading />;
                    }

                    if (!data) {
                        return (
                            <NonIdealState
                                title="No Tag Sets"
                                description="Nothing available to choose from"
                            />
                        );
                    }

					const selectedIds = (state.selected || []).map((s) => s.id);

                    // TODO improve menu tree concept

                    // provide instance to tag set label so that you can override/extend the name for this form,
                    // but still fall back to tag set name
                    return (
                        <RowsView 
                            viewKey="results-row"
                            items={data}
                            renderItem={(ts) => (
                                <BlockView key={ts.id} viewKey="tagSet">
                                    <HeadingView viewKey="tagSet.name">
                                        <Label k={`TagSet.${ts.id}.name`} v={ts.name} args={{user: TokenSession.getUser().getName()}} instances={[instance, id]} />
                                    </HeadingView>
                                    <SeparatorView viewKey="results-seperator" />
                                    <MenuTreeView
                                        viewKey="tags.menu"
                                        items={
                                            (ts.tags || []).map<IMenuNode>((tag) => ({
                                                id: tag.id,
                                                data: tag,
                                                label: <Label k={`Tag.${tag.id}.name`} v={tag.name} />,
                                                isActive: selectedIds.indexOf(tag.id) > -1,
                                                className: `tag-${StringUtil.sanitize(tag.name)}`
                                            }))
                                        }
                                        onSelectItem={onSelectTag}
                                        onExpandedStateChange={() => null}
                                    />
                                </BlockView>
                            )}
                        />
                    );
                }
            }
        </Query.Many>
    )
};

export const SubmitButton: Fragment<ITagFragmentProps> = {
    name: "Submit",
    component: ({onSubmit, state}) => (
        <ButtonView loading={state.saving} viewKey="edit.submit" onClick={onSubmit}>
            {state.changed ? <Labels.Save /> : <Labels.Close /> }
        </ButtonView>
    )
};



// WEBPACK FOOTER //
// ./src/panels/tags/fragments/fragments.tsx